export const MODAL_LOGIN = 'LOGIN'
export const MODAL_SIGN_UP = 'SIGN_UP'
